var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { bordered: false } },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "j-form-container",
            { attrs: { disabled: _vm.formDisabled } },
            [
              _c(
                "a-form-model",
                {
                  ref: "form",
                  attrs: {
                    slot: "detail",
                    model: _vm.model,
                    "label-col": _vm.labelCol1,
                    "wrapper-col": _vm.wrapperCol1,
                    rules: _vm.validatorRules
                  },
                  slot: "detail"
                },
                [
                  _c(
                    "a-row",
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["cs.floorcode"],
                                prop: "floorcode"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: this.language["cs.floorcode"],
                                  maxLength: 50
                                },
                                model: {
                                  value: _vm.model.floorcode,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "floorcode", $$v)
                                  },
                                  expression: "model.floorcode"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["cs.floorname"],
                                prop: "floorname"
                              }
                            },
                            [
                              _c("a-input", {
                                attrs: {
                                  placeholder: this.language["cs.floorname"],
                                  maxLength: 60
                                },
                                model: {
                                  value: _vm.model.floorname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "floorname", $$v)
                                  },
                                  expression: "model.floorname"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: this.language["common.uploadPicture"],
                                labelCol: _vm.labelCol1,
                                wrapperCol: _vm.wrapperCol1,
                                prop: "files"
                              }
                            },
                            [
                              _c("j-image-upload", {
                                staticClass: "avatar-uploader",
                                attrs: {
                                  text: "上传",
                                  "upload-source": _vm.uploadSource,
                                  isMultiple: true,
                                  disabled: _vm.disableSubmit
                                },
                                model: {
                                  value: _vm.model.files,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "files", $$v)
                                  },
                                  expression: "model.files"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "a-tabs",
        {
          on: { change: _vm.handleChangeTabs },
          model: {
            value: _vm.activeKey,
            callback: function($$v) {
              _vm.activeKey = $$v
            },
            expression: "activeKey"
          }
        },
        [
          _c(
            "a-tab-pane",
            {
              key: _vm.refKeys[0],
              attrs: { tab: "區域設置信息", forceRender: true }
            },
            [
              _c("j-editable-table", {
                ref: _vm.refKeys[0],
                attrs: {
                  loading: _vm.areas.loading,
                  columns: _vm.columns,
                  dataSource: _vm.areas.dataSource,
                  maxHeight: 400,
                  maxNumber: 100,
                  disabled: _vm.formDisabled,
                  rowNumber: true,
                  rowSelection: true,
                  actionButton: true
                },
                on: { valueChange: _vm.valueChange }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }